export default __webpack_public_path__ + "static/media/terrible.88a87411.svg";